// =====================================================
// KB-CART-TEMPLATES-CORE.JS
// Общая логика галерей шаблонов:
//   - Галерея 1: текущие макеты из корзины (для всех)
//   - Утилиты рендера карточек и слайдера
// Зависит от: kb-cart-individualisierung.js (window.kbCartIndividualisierung)
// =====================================================

(function () {

  const SLIDER_THRESHOLD = 4;
  const GALLERY1_ENABLED = true; // ← false чтобы отключить Галерею 1

  // =====================
  // ⏳ Ждём публичного интерфейса основного скрипта
  // =====================
  function waitForCore(cb, attempts = 20) {
    if (window.kbCartIndividualisierung) {
      cb(window.kbCartIndividualisierung);
    } else if (attempts > 0) {
      setTimeout(() => waitForCore(cb, attempts - 1), 150);
    } else {
      console.warn('⚠️ kb-cart-templates-core: kbCartIndividualisierung not found');
    }
  }

  // =====================
  // 🃏 Рендер одной карточки шаблона
  // =====================
  function renderCard(card, onSelect, isActive) {
    const el = document.createElement('div');
    el.className = 'kb-tpl-card' + (isActive ? ' kb-tpl-card--active' : '');
    el.style.cssText = `
      cursor:pointer;
      border:3px solid ${isActive ? '#910045' : '#e0e0e0'};
      border-radius:6px;
      overflow:hidden;
      transition:border-color 0.2s, box-shadow 0.2s;
      background:#fff;
      flex:0 0 120px;
      width:120px;
      position:relative;
    `;

    const imgHtml = card.fileUrl
      ? `<img src="${card.fileUrl}" alt="${card.label}"
            style="width:100%;height:110px;object-fit:contain;display:block;background:#f9f9f9;"
            onerror="this.style.display='none';this.nextElementSibling.style.display='flex';">
         <div style="display:none;width:100%;height:110px;align-items:center;justify-content:center;
              background:#f5f5f5;color:#bbb;font-size:28px;">🖼️</div>`
      : `<div style="width:100%;height:110px;display:flex;align-items:center;justify-content:center;
              background:#f5f5f5;color:#bbb;font-size:28px;">🖼️</div>`;

    el.innerHTML = `
      ${imgHtml}
      <div style="padding:5px 4px;text-align:center;font-size:11px;line-height:1.3;
           background:${isActive ? '#910045' : '#f5f5f5'};
           color:${isActive ? '#fff' : '#333'};
           min-height:28px;display:flex;align-items:center;justify-content:center;">
        ${card.label}
      </div>
      ${isActive ? `<div style="position:absolute;top:4px;right:4px;background:#910045;color:#fff;
          border-radius:50%;width:20px;height:20px;display:flex;align-items:center;
          justify-content:center;font-size:12px;font-weight:bold;">✓</div>` : ''}
    `;

    el.addEventListener('mouseenter', () => {
      if (!el.classList.contains('kb-tpl-card--active')) {
        el.style.borderColor = '#910045';
        el.style.boxShadow = '0 2px 8px rgba(145,0,69,0.15)';
      }
    });
    el.addEventListener('mouseleave', () => {
      if (!el.classList.contains('kb-tpl-card--active')) {
        el.style.borderColor = '#e0e0e0';
        el.style.boxShadow = '';
      }
    });

    el.addEventListener('click', () => onSelect(card.templateId, card.fileUrl));

    return el;
  }

  // =====================
  // 🎠 Обёртка: сетка или слайдер
  // =====================
  function renderGalleryWidget(cards, activeTemplateId, activeFileUrl, onSelect) {
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'margin-bottom:15px;';

    if (cards.length === 0) return wrapper;

    const useSlider = cards.length > SLIDER_THRESHOLD;

    if (useSlider) {
      const sliderWrap = document.createElement('div');
      sliderWrap.style.cssText = 'position:relative;';

      const track = document.createElement('div');
      track.style.cssText = `
        display:flex;gap:10px;overflow-x:auto;scroll-behavior:smooth;
        padding:4px 2px 8px;scrollbar-width:thin;
        scrollbar-color:#ddd transparent;
        -ms-overflow-style:none;
      `;

      cards.forEach(card => {
        const isActive = (activeTemplateId && card.templateId === activeTemplateId)
                      || (activeFileUrl && card.fileUrl === activeFileUrl);
        track.appendChild(renderCard(card, onSelect, isActive));
      });

      const btnPrev = document.createElement('button');
      btnPrev.type = 'button';
      btnPrev.innerHTML = '&#8249;';
      btnPrev.style.cssText = `
        position:absolute;left:-14px;top:50%;transform:translateY(-60%);
        background:#910045;color:#fff;border:none;border-radius:50%;
        width:28px;height:28px;font-size:18px;line-height:1;
        cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;
        box-shadow:0 2px 6px rgba(0,0,0,0.2);
      `;
      btnPrev.addEventListener('click', () => track.scrollBy({ left: -260, behavior: 'smooth' }));

      const btnNext = document.createElement('button');
      btnNext.type = 'button';
      btnNext.innerHTML = '&#8250;';
      btnNext.style.cssText = `
        position:absolute;right:-14px;top:50%;transform:translateY(-60%);
        background:#910045;color:#fff;border:none;border-radius:50%;
        width:28px;height:28px;font-size:18px;line-height:1;
        cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;
        box-shadow:0 2px 6px rgba(0,0,0,0.2);
      `;
      btnNext.addEventListener('click', () => track.scrollBy({ left: 260, behavior: 'smooth' }));

      sliderWrap.appendChild(btnPrev);
      sliderWrap.appendChild(track);
      sliderWrap.appendChild(btnNext);
      wrapper.appendChild(sliderWrap);

    } else {
      const grid = document.createElement('div');
      grid.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;';
      cards.forEach(card => {
        const isActive = (activeTemplateId && card.templateId === activeTemplateId)
                      || (activeFileUrl && card.fileUrl === activeFileUrl);
        grid.appendChild(renderCard(card, onSelect, isActive));
      });
      wrapper.appendChild(grid);
    }

    return wrapper;
  }

  // =====================
  // 🛒 Галерея 1: текущие макеты из корзины
  // templateType: фильтр по типу центра текущего товара
  // =====================
  async function renderCartTemplatesGallery(core, templateType) {
    const container = document.getElementById('kb-gallery-cart-templates');
    if (!container) return;

    container.innerHTML = '';

    let cartData;
    try {
      cartData = await fetch('/cart.js').then(r => r.json());
    } catch (e) {
      console.warn('kb-gallery-cart-templates: failed to fetch cart', e);
      return;
    }

    const { PROPERTY_NAMES, LANG, readProp } = core;
    const P = PROPERTY_NAMES[LANG] || PROPERTY_NAMES.de;

    const seen = new Set();
    const cards = [];

    (cartData.items || []).forEach(item => {
      const props = item.properties || {};
      const templateId = props[P.templateNo] || '';
      const fileUrl    = readProp(props, P, 'imageUrl') || '';

      if (!templateId && !fileUrl) return;

      // Фильтрация по типу центра
      if (templateType) {
        const centerValue = readProp(props, P, 'center') || props[P.center] || '';
        const itemType = getTemplateTypeFromZentrum(centerValue, core);
        if (itemType !== templateType) return;
      }

      const key = templateId || fileUrl;
      if (seen.has(key)) return;
      seen.add(key);

      cards.push({
        templateId: templateId, // пустая строка если нет templateNo
        fileUrl,
        label: templateId || '—'
      });
    });

    if (cards.length === 0) return;

    const title = document.createElement('div');
    title.style.cssText = 'font-weight:bold;font-size:13px;color:#555;margin-bottom:8px;';
    title.textContent = _galleryLabel('cart', core);
    container.appendChild(title);

    // Активный макет текущего товара
    const modal = document.getElementById('individ-modal');
    let activeTemplateId = null;
    let activeFileUrl = null;
    if (modal && modal.dataset.key) {
      try {
        const currentCart = await fetch('/cart.js').then(r => r.json());
        const currentItem = currentCart.items.find(i => i.key === modal.dataset.key);
        if (currentItem) {
          activeTemplateId = (currentItem.properties || {})[P.templateNo] || null;
          activeFileUrl    = readProp(currentItem.properties || {}, P, 'imageUrl') || null;
        }
      } catch (e) {}
    }

    container.appendChild(
      renderGalleryWidget(cards, activeTemplateId, activeFileUrl, (templateId, fileUrl) => {
        core.onTemplateSelect(templateId, fileUrl);
        setTimeout(() => renderCartTemplatesGallery(core, templateType), 50);
      })
    );

    const sep = document.createElement('div');
    sep.style.cssText = 'height:1px;background:#eee;margin:12px 0;';
    container.appendChild(sep);
  }

  // =====================
  // 🏷️ Локализованные заголовки галерей
  // =====================
  function _galleryLabel(type, core) {
    const labels = {
      cart: {
        de: 'Bereits verwendete Vorlagen',
        en: 'Previously used templates',
        nl: 'Eerder gebruikte sjablonen',
        es: 'Plantillas usadas anteriormente',
        dk: 'Tidligere brugte skabeloner'
      },
      customer: {
        de: 'Ihre Vorlagen',
        en: 'Your templates',
        nl: 'Uw sjablonen',
        es: 'Sus plantillas',
        dk: 'Dine skabeloner'
      }
    };
    return (labels[type] || {})[core.LANG] || labels[type].de;
  }

  // =====================
  // 🔍 Определить тип шаблона по значению zentrumstyp
  // =====================
  function getTemplateTypeFromZentrum(zentrumValue, core) {
    if (!zentrumValue) return null;
    const { matchOption } = core;
    if (matchOption(zentrumValue, 'optionFoil'))    return 'zentrum_foliendruck';
    if (matchOption(zentrumValue, 'optionDigital')) return 'zentrum_mehrfarbiger_digitaldruck';
    return null;
  }

  // =====================
  // 🌐 Публичный интерфейс для дочерних скриптов
  // =====================
  window.kbCartTemplatesCore = {
    renderCartTemplatesGallery,
    renderGalleryWidget,
    getTemplateTypeFromZentrum,
    galleryLabel: _galleryLabel,
    SLIDER_THRESHOLD
  };

  // =====================
  // 🚀 Инициализация
  // =====================
  waitForCore(core => {
    let currentTemplateType = null;

    document.addEventListener('kb:modalOpened', () => {
      const zentrumSelect = document.getElementById('zentrumstyp');
      currentTemplateType = getTemplateTypeFromZentrum(
        zentrumSelect ? zentrumSelect.value : '', core
      );
      if (GALLERY1_ENABLED) {
        renderCartTemplatesGallery(core, currentTemplateType);
      }
    });

    document.addEventListener('kb:zentrumTypeChanged', (e) => {
      const newType = getTemplateTypeFromZentrum(e.detail.value, core);
      if (newType !== currentTemplateType) {
        currentTemplateType = newType;
        if (GALLERY1_ENABLED) {
          renderCartTemplatesGallery(core, currentTemplateType);
        }
      }
    });
  });

})();
